import { createOpenAI } from "@ai-sdk/openai";
import { customProvider } from "ai";
import { isTestEnvironment } from "../constants";

const openai = createOpenAI();

export const myProvider = isTestEnvironment
  ? (() => {
      const {
        chatModel,
        reasoningModel,
        titleModel,
      } = require("./models.mock");
      return customProvider({
        languageModels: {
          "chat-model": chatModel,
          "chat-model-reasoning": reasoningModel,
          "title-model": titleModel,
        },
      });
    })()
  : customProvider({
      languageModels: {
        "chat-model": openai.languageModel("gpt-5.1-codex-mini"),
        "chat-model-reasoning": openai.languageModel("gpt-5.1-codex-mini"),
        "title-model": openai.languageModel("gpt-5.1-codex-mini"),
      },
    });
